import api from '../../api/index.api'
import OrderTypes from './order.types'

export const onSendNotifications = (_data, cb) => {
	return async () => {
		try {
			const result = await api.notificationApi.sendNotification()
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onGetListOrders = (data, cb) => {
	return async dispatch => {
		try {
			const result = await api.orderApi.getAll(data)
			result.currentPage = data.pageNum + 1
			dispatch({
				type: OrderTypes.GET_LIST_ORDERS,
				payload: result,
			})
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onConfirmOrder = (data, cb) => {
	return async dispatch => {
		try {
			const result = await api.orderApi.confirmOrder(data)
			dispatch({
				type: OrderTypes.CONFIRM_ORDER,
				payload: result,
			})
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onCreateOrderManual = (data, fCallBack) => {
	return async dispatch => {
		try {
			const rs = await api.orderApi.create(data)

			dispatch({
				type: OrderTypes.CREATE_ORDER_MANUAL,
				payload: rs,
			})
			fCallBack && fCallBack(true, rs)
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}
